import { Routes } from '@angular/router';
//import { ThanksforsubscribingComponent } from './components/thanksforsubscribing/thanksforsubscribing.component';
import { HomepageComponent } from './components/homepage/homepage.component';
export const routes: Routes = [
    { path: '', component: HomepageComponent },
    {
        path: 'login',
        loadChildren: () => import('./components/login/login.routes').then(m => m.LoginRoute)
    },
    {
        path: 'influencer-login',
        loadChildren: () => import('./components/influencer-login/influencer-login.routes').then(m => m.InfluencerLoginRoute)
    },
    {
        path: 'notifications',
        loadChildren: () => import('./components/notifications/notifications.routes').then(m => m.NotificationsRoute)
    },
    {
        path: 'locations',
        loadChildren: () => import('./components/countries-locations/countries-locations.routes').then(m => m.CountriesLocationsRoute)
    },
    // {
    //     path: 'exp-footer-detail',
    //     loadChildren: () => import('./components/exp-footer-detail/exp-footer-detail.routes').then(m => m.ExpFooterDetailRoute)
    // },
    {
        path: 'experience',
        loadChildren: () => import('./components/experiences-listing/experiences-listing.routes').then(m => m.ExperiencesListingRoute)
    },
    {
        path: 'google-callback',
        loadChildren: () => import('./components/callBack/callBack.routes').then(m => m.CallBackRoute)

    },
    {
        path: 'thanksforsubscribing',
        loadChildren: () => import('./components/thanksforsubscribing/thanksforsubscribing.routes').then(m => m.ThanksforsubscribingRoute)
    },
    {
        path: 'registration/charity',
        loadChildren: () => import('./components/register/charity/charity.routes').then(m => m.ChairtyRoute)
    },
    {
        path: 'add-experience-by-city',
        loadChildren: () => import('./components/add-experience-by-city/add-experience-by-city.routes').then(m => m.AddExperienceByCityRoute)
    },
    {
        path: 'add-experience-by-region',
        loadChildren: () => import('./components/add-experience-by-region/add-experience-by-region.routes').then(m => m.AddExperienceByRegionRoute)
    },
    {
        path: 'about',
        loadChildren: () => import('./components/about/about.routes').then(m => m.AboutRoute)
    },
    {
        path: 'find-couple',
        loadChildren: () => import('./components/find-couple/find-couple.routes').then(m => m.FindCoupleRoute)
    },
    {
        path: 'registration/wedding-couple',
        loadChildren: () => import('./components/register/wedding-couple/wedding-couple.routes').then(m => m.WeddingCoupleRoute)
    },

    {
        path: 'registration/individual',
        loadChildren: () => import('./components/register/individual/individual.routes').then(m => m.IndividualRoute)
    },
    {
        path: 'registration/experience-provider',
        loadChildren: () => import('./components/register/experience-provider/experience-provider.routes').then(m => m.ExperienceProviderRoute)
    },
    {
        path: 'registration/bbb-registration',
        loadChildren: () => import('./components/register/bbb/bbb.routes').then(m => m.BBBRoute)
    },

    // add-experiences: owlOptions,stickySideBar
    {
        path: 'add-experiences',
        loadChildren: () => import('./components/add-experiences/add-experiences.routes').then(m => m.AddExperienceRoute)
    },

    {
        path: 'gift-tracker',
        loadChildren: () => import('./components/gift-tracker/gift-tracker.routes').then(m => m.GiftTrackerRoute)
    },
    {
        path: 'sendoso',
        loadChildren: () => import('./components/sendoso/sendoso.routes').then(m => m.SendosoRoute)
    },
    {
        path: 'sendoso-shop',
        loadChildren: () => import('./components/sendoso-shop/sendoso-shop.routes').then(m => m.SendosoRoute)
    },
    {
        path: 'postal',
        loadChildren: () => import('./components/postal/postal.routes').then(m => m.PostalRoute)
    },
    {
        path: 'postal-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'inbox',
        loadChildren: () => import('./components/inbox/inbox.routes').then(m => m.InboxRoute)
    },
    {
        path: 'influencer-ep-inbox',
        loadChildren: () => import('./components/influencer-ep-inbox/influencer-ep-inbox.routes').then(m => m.InfluencerEpInboxRoute) 
    },
    {
        path: 'artical-detail',
        loadChildren: () => import('./components/artical-details/artical-details.routes').then(m => m.ArticalDetailsRoute)

    },
    {
        path: 'blog',
        loadChildren: () => import('./components/blog/blog.routes').then(m => m.BlogRoute)
    },
    {
        path: 'blog-detail/:slug',
        loadChildren: () => import('./components/blog-details/blog-details.routes').then(m => m.BlogDetailsRoute)
    },
    {
        path: 'category-blog/:slug',
        loadChildren: () => import('./components/category-blog/category-blog.routes').then(m => m.CategoryBlogRoute)
    },
    {
        path: 'cart',
        loadChildren: () => import('./components/cart/cart.routes').then(m => m.CartRoute)
    },
    {
        path: 'charities',
        loadChildren: () => import('./components/charity/charity.routes').then(m => m.CharityRoute)
    },
    {
        path: 'charity-category/:string',
        loadChildren: () => import('./components/charity-category/charity-category.routes').then(m => m.CharityCategoryRoute)
    },
    {
        path: 'experience-provider-add',
        loadChildren: () => import('./components/add-experience-provider/add-experience-provider.routes').then(m => m.AddExperienceProviderRoute)
    },
    {
        path: 'experience-name-search',
        loadChildren: () => import('./components/experience-name-search/experience-name-search.routes').then(m => m.ExperienceNameSearchRoute)
    },
    {
        path: 'charity-couple',
        loadChildren: () => import('./components/charity-couple/charity-couple.routes').then(m => m.CharityCoupleRoute)
    },
    {
        path: 'checkout',
        loadChildren: () => import('./components/checkout/checkout.routes').then(m => m.CheckoutRoute)
    },
    // {
    //     path: 'checkout',
    //     loadChildren: () => import('./components/checkout2/checkout.routes').then(m => m.CheckoutRoute)
    // },
    {
        path: 'claim-voucher',
        loadChildren: () => import('./components/claim-voucher/claim-voucher.routes').then(m => m.ClaimVoucherRoute)
    },
    {
        path: 'continents/:slug',
        loadChildren: () => import('./components/continent/continent.routes').then(m => m.ContinentRoute)
    },
    {
        path: 'continents/:slug/:slug',
        loadChildren: () => import('./components/continent/continent.routes').then(m => m.ContinentRoute)
    },
    {
        path: 'customer-support',
        loadChildren: () => import('./components/customer-support/customer-support.routes').then(m => m.CustomerSupportRoute)
    },
    {
        path: 'edit-experience',
        loadChildren: () => import('./components/ep-dashboard/edit-experience/edit-experience.routes').then(m => m.EditExperienceRoute)
    },
    {
        path: 'booking-calendar',
        loadChildren: () => import('./components/ep-dashboard/ep-booking-calender/ep-booking-calender.routes').then(m => m.EpBookingCalenderRoute)
    },
    {
        path: 'edit-charity',
        loadChildren: () => import('./components/edit-charity/edit-charity.routes').then(m => m.EditCharityRoute)
    },
    {
        path: 'provider/ep-providers/:slug',
        loadChildren: () => import('./components/ep-providers/ep-providers.routes').then(m => m.EpProvidersRoute)
    },
    {
        path: 'experiences/:slug',
        loadChildren: () => import('./components/exp-detail2/exp-detail.routes').then(m => m.ExpDetailRoute2),
    },
    // {
    //     path:'experiences-new/:slug',
    //     loadChildren: () => import('./components/exp-detail-new/exp-detail-new.routes').then(m => m.ExpDetailNewRoute)
    // },
    {
        path: 'experiences',
        loadChildren: () => import('./components/experiences/experiences.routes').then(m => m.ExperienceRegionCategoryRoute)
    },
    {
        path: 'experience-search-booking',
        loadChildren: () => import('./components/experience-search-booking/experience-search-booking.routes').then(m => m.ExperienceSearchBookingRoute)
    },
    {
        path: 'faqs',
        loadChildren: () => import('./components/faqs/faqs.routes').then(m => m.FaqsRoute)
    },
    {
        path: 'faq-cate-details/:string',
        loadChildren: () => import('./components/faq-cate-details/faq-cate-details.routes').then(m => m.FaqCateDetailsRoute)
    },
    {
        path: 'faq-category/:string',
        loadChildren: () => import('./components/faq-category/faq-category.routes').then(m => m.FaqCategoryRoute)
    },
    {
        path: 'find-vebso-couples',
        loadChildren: () => import('./components/find-vebo-couples/find-vebo-couples.routes').then(m => m.FindVeboCoupleRoute)
    },
    {
        path: 'gift-card',
        loadChildren: () => import('./components/gift-card/gift-card.routes').then(m => m.GiftCardRoute) 
    },
    {
        path: 'list-influencers',
        loadChildren: () => import('./components/list-influencers/list-influencers.routes').then(m => m.ListInfluencersdRoute) 
    },
    {
        path: 'influencer/:slug',
        loadChildren: () => import('./components/influencer-details/influencer-details.routes').then(m => m.InfluencerDetailRoute),
    },
    {
        path: 'gift-ideas-category/:slug',
        loadChildren: () => import('./components/gift-ideas/gift-category/gift-category.routes').then(m => m.GiftCategoryRoute)
    },
    {
        path: 'gift-ideas',
        loadChildren: () => import('./components/gift-ideas/gift-ideas.routes').then(m => m.GiftIdeasRoute)
    },
    {
        path: 'experience/:slug',
        loadChildren: () => import('./components/high-level-category/high-level-category.routes').then(m => m.HighLevelCategoryRoute)
    },
    {
        path: 'at-home-experiences',
        loadChildren: () => import('./components/home-exp/home-experience.routes').then(m => m.HomeExperienceRoute)
    },
    {
        path: 'howitwork',
        loadChildren: () => import('./components/how-it-work/how-it-work.routes').then(m => m.HowItWorkRoute)
    },
    {
        path: 'influencers',
        loadChildren: () => import('./components/influencer/influencer.routes').then(m => m.InfluencerRoute)
    },
    {
        path: 'joy',
        loadChildren: () => import('./components/joy/joy.routes').then(m => m.JoyRoute)
    },
    {
        path: 'knot',
        loadChildren: () => import('./components/knot/knot.routes').then(m => m.KnotRoute)
    },
    {
        path: 'theknot',
        loadChildren: () => import('./components/knot/knot.routes').then(m => m.KnotRoute)
    },
    {
        path: 'tk',
        loadChildren: () => import('./components/knot/knot.routes').then(m => m.KnotRoute)
    },
    {
        path: 'withjoy',
        loadChildren: () => import('./components/joy/joy.routes').then(m => m.JoyRoute)
    },
    {
        path: 'locations/:string',
        loadChildren: () => import('./components/location/location.routes').then(m => m.LocationRoute)
    },
    {
        path: 'location-region',
        loadChildren: () => import('./components/location-region/location-region.routes').then(m => m.LocationRegionRoute)
    },
    // {
    //     path: 'location-region-new',
    //     loadChildren: ()=> import('./components/location-region-new/location-region-new.routes').then(m => m.LocationRegionNewRoute)
    // },
    {
        path: 'lostPass',
        loadChildren: () => import('./components/lost-password/lost-password.routes').then(m => m.LostPasswordRoute)
    },
    {
        path: 'reset-password',
        loadChildren: () => import('./components/reset-password/reset-password.routes').then(m => m.ResetPasswordRoute)
    },
    {
        path: 'vebo-map-app-view',
        loadChildren: () => import('./components/map-app-view/map-app-view.routes').then(m => m.MapAppViewRoute)
    },
    {
        path: 'country-location',
        loadChildren: () => import('./components/location-region/location-region.routes').then(m => m.LocationRegionRoute)
    },
    {
        path: 'master-login/:string',
        loadChildren: () => import('./components/master-login/master-login.routes').then(m => m.MasterLoginRoute)
    },
    {
        path: 'partner-signup/:string',
        loadChildren: () => import('./components/partner-signup/partner-signup.routes').then(m => m.PartnerSignupRoute)
    },
    {
        path: 'our-friends',
        loadChildren: () => import('./components/my-friends/my-friends.routes').then(m => m.MyFriendsRoute) 
    },
    {
        path: 'influencer-details',
        loadChildren: () => import('./components/individual-after-login/influencer-details/influencer-details.routes').then(m => m.InfluencerDetailRoute) 
    },
    {
        path: 'my-friends',
        loadChildren: () => import('./components/my-friends/my-friends.routes').then(m => m.MyFriendsRoute)
    },
    {
        path: 'news-feeds',
        loadChildren: () => import('./components/news-feed/news-feed.routes').then(m => m.NewsFeedRoute)
    },
    {
        path: 'payment-failed',
        loadChildren: () => import('./components/payment-failed/payment-failed.routes').then(m => m.PaymentFailedRoute)
    },
    {
        path: 'paypal-response',
        loadChildren: () => import('./components/paypal-response/paypal-response.routes').then(m => m.PaypalResponseRoute)
    },
    {
        path: 'persona-landing',
        loadChildren: () => import('./components/persona-landing/persona-landing.routes').then(m => m.PersonaLandingRoute)
    },
    {
        path: 'press',
        loadChildren: () => import('./components/press/press.routes').then(m => m.PressRoute)
    },
    {
        path: 'profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'ep-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'ep-overview',
        loadChildren: () => import('./components/ep-dashboard/ep-dashboard.routes').then(m => m.EpDashboardRoute)
    },
    {
        path: 'bbb-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'knot-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'joy-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'zola-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'sendoso-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'thnks-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'your-profile/charity',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'my-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'providers',
        loadChildren: () => import('./components/providers/providers.routes').then(m => m.ProvidersRoute)
    },
    {
        path: 'refer-friends',
        loadChildren: () => import('./components/refer-friends/refer-friends.routes').then(m => m.ReferFriendsRoute)
    },
    {
        path: 'registries/:string',
        loadChildren: () => import('./components/registries/registries.routes').then(m => m.RegistriesRoute)
    },
    {
        path: 'track-sale',
        loadChildren: () => import('./components/registerfinder-after-login/track-sale/track-sale.routes').then(m => m.TrackSaleRoute)
    },
    {
        path: 'track-referal-link',
        loadChildren: () => import('./components/registerfinder-after-login/track-referal/track-referal.routes').then(m => m.TrackReferalRoute)
    },
    // {
    //     path: 'track-sale',
    //     loadChildren: () => import('./components/registerfinder-after-login/registerfinder.routes').then(m => m.RegisterfinderRoute)
    // },
    {
        path: 'settings',
        loadChildren: () => import('./components/settings/settings.routes').then(m => m.SettingsRoute)
    },
    {
        path: 'my-settings',
        loadChildren: () => import('./components/settings/settings.routes').then(m => m.SettingsRoute)
    },
    {
        path: 'experience-settings',
        loadChildren: () => import('./components/ep-dashboard/experience-settings/experience-settings.routes').then(m => m.SettingsRoute)
    },
    {
        path: 'experience-availability',
        loadChildren: () => import('./components/ep-dashboard/exp-availability/exp-availability.routes').then(m => m.ExpAvailabilityRoute)
    },
    {
        path: 'exp-booking',
        loadChildren: () => import('./components/ep-dashboard/exp-booking/exp-booking.routes').then(m => m.ExpBookingRoute)
    },
    {
        path: 'your-profile/experience-provider',
        loadChildren: () => import('./components/ep-dashboard/voucher-redeem/voucher-redeem.routes').then(m => m.VoucherRedeemRoute)
    },
    {
        path: 'charity-settings',
        loadChildren: () => import('./components/settings/settings.routes').then(m => m.SettingsRoute)
    },
    {
        path: 'thankyou-booking',
        loadChildren: () => import('./components/thank-you/thank-you.routes').then(m => m.ThankYouRoute)
    },
    {
        path: 'thankyou',
        loadChildren: () => import('./components/thank-you/thank-you.routes').then(m => m.ThankYouRoute)
    },
    {
        path: 'thank-you',
        loadChildren: () => import('./components/thank-you-order/thank-you-order.routes').then(m => m.ThanksYouOrderRoute)
    },
    {
        path: 'tiktok',
        loadChildren: () => import('./components/tiktok/tiktok.routes').then(m => m.TiktokRoute)
    },
    {
        path: 'tickets',
        loadChildren: () => import('./components/tickets/tickets.routes').then(m => m.TicketsRoute)
    },
    {
        path: 'ticket-map-web-view',
        loadChildren: () => import('./components/ticket-map-web-view/ticket-map-web-view.routes').then(m => m.TicketMapWebViewRoute)
    },
    {
        path: 'top-ten-category',
        loadChildren: () => import('./components/top-ten-category/top-ten-category.routes').then(m => m.TopTenCategoryRoute)
    },
    {
        path: 'find-vebo-couples',
        loadChildren: () => import('./components/find-vebo-couples/find-vebo-couples.routes').then(m => m.FindVeboCoupleRoute)
    },
    {
        path: 'vebo-seats',
        loadChildren: () => import('./components/vebo-seats/vebo-seats.routes').then(m => m.VeboSeatsRoute)
    },
    // {
    //     path: '',
    //     loadChildren: () => import('./components/veboticketing/veboticketing.routes').then(m => m.VeboTicketingRoute)
    // },
    {
        path: 'ticket-category',
        loadChildren: () => import('./components/veboticketing/all-events/all-events.routes').then(m => m.AllEventRoute)
    },
    {
        path: 'our-tickets',
        loadChildren: () => import('./components/veboticketing/our-tickets/our-tickets.routes').then(m => m.OurTicketsRoute)
    },
    {
        path: 'ticket-evolution-category/:slug',
        loadChildren: () => import('./components/veboticketing/ticket-evolution-category/ticket-evolution-category.routes').then(m => m.TicketEvolutionCategoryRoute)
    },
    {
        path: 'view-all-voucher',
        loadChildren: () => import('./components/view-all-voucher/view-all-voucher.routes').then(m => m.ViewAllVoucherRoute)
    },
    {
        path: 'wedding-registry',
        loadChildren: () => import('./components/weddingregistry/weddingregistry.routes').then(m => m.WeddingregistryRoute)
    },
    {
        path: 'registry',
        loadChildren: () => import('./components/wedding-couple-registry/wedding-couple-registry.routes').then(m => m.WeddingCoupleRegistryRoute)
    },
    /*
    **{
        path: 'weddingregistry',
        loadChildren: () => import('./components/weddingregistry/weddingregistry.routes').then(m => m.WeddingregistryRoute)
    },
    */
    {
        path: 'whyregisterwithspur',
        loadChildren: () => import('./components/whyregisterwithcouple/whyregisterwithcouple.routes').then(m => m.WhyregisterwithcoupleRoute)
    },
    {
        path: 'zola',
        loadChildren: () => import('./components/zola/zola.routes').then(m => m.ZolaRoute)
    },
    {
        path: '**',
        loadChildren: () => import('./components/not-found/not-found.routes').then(m => m.NotFoundRoute)
    },
    {
        path: '404',
        loadChildren: () => import('./components/not-found/not-found.routes').then(m => m.NotFoundRoute)
    },

];
